import { render, staticRenderFns } from "./ProjectBriefPrintView.vue?vue&type=template&id=7af5dd56&"
import script from "./ProjectBriefPrintView.vue?vue&type=script&lang=js&"
export * from "./ProjectBriefPrintView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports